import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

// TA_VAR ignores its nbdev argument (TA_INT_VAR never reads it), so it is not an input.
const def: IndicatorDef = {
  id: 'VAR',
  version: 1,
  label: 'Variance',
  pane: 'sub',
  category: 'statistics',
  series: 'normal',
  precision: 4,
  order: 20,
  inputs: [period('timeperiod', 20)],
  outputs: [line('var', 'Variance', COLOR.blue)],
  talib: { functions: ['VAR'], expr: 'VAR(close, timeperiod={timeperiod}, nbdev=1)' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
